import React, { useState, useEffect } from "react";
import "./CartBox.css";
import classNames from "classnames";
import { LimaOrderStatus } from "../../../utils/Constants";
import { isDevelopmentEnv } from "../../../utils/environment/environmentUtils";
import { mapWorkstationToSize } from "../../../utils/helpers/workstationHelper";
import { Icon } from "semantic-ui-react";

interface IBox {
  boxID: number;
  packable: boolean;
  selectable: boolean;
  deadlineUrgent: boolean;
  deadlinePassed: boolean;
  deadlinePriority: number;
  orderStatus: number;
  wasCancelled: boolean;
  isLocked: boolean;
  shelfNumber: number;
  lockedWorkstation: number;
  isLockedByName: string;
  prefilled: number;
}

interface ICartBoxProps {
  getSortBox: (scan: string | null, forceShelf?: number) => void;
  box: IBox;
  currentBoxID: number;
  handleSingleShelf: () => void;
}

const CartBox = ({ getSortBox, box, currentBoxID, handleSingleShelf }: ICartBoxProps) => {
  let { packable, selectable, isLocked, deadlineUrgent, deadlinePassed, deadlinePriority } = box;

  selectable = selectable && packable && getSortBox !== undefined && getSortBox !== null;
  // ||isDevelopmentEnv();
  deadlineUrgent = deadlineUrgent && packable;
  deadlinePassed = deadlinePassed && packable;

  let outerDivClasses = classNames({
    "shelf-box": true,
    current: currentBoxID === box.boxID,
    "cart-box-clickable": selectable,
    "cart-box-urgent": deadlineUrgent,
    "cart-box-passed": deadlinePassed,
    "cart-box-not-accessible": !packable,
    "cart-box-sent": box.orderStatus === LimaOrderStatus.Levererad,
    "cart-box-frozen": box.orderStatus === LimaOrderStatus.Frusen,
    "cart-box-orderkontroll": box.orderStatus === LimaOrderStatus.Orderkontroll,
    "cart-box-cancelled": box.wasCancelled,
    "cart-box-locked": box.isLocked,
    "cart-box-prefilled": box.prefilled > 0,
  });

  let iconClasses = classNames({
    "shipping large icon packprio": deadlinePriority && !isLocked,
    "lock large icon packprio": isLocked,
    hidden: !deadlinePriority && !isLocked,
  });

  const selfRef = React.createRef<HTMLInputElement>();
  const [showLock, setShowLock] = useState(false);

  //MÅSTE TESTAS EFTER INFLYTTNING! //JOMO
  useEffect(() => {
    function showLocker(e: Event) {
      if (
        selfRef.current &&
        (selfRef.current.contains(e.target as Node) || selfRef.current === e.target)
      ) {
        setShowLock(!showLock);
      } else if (showLock) {
        setShowLock(false);
      }
    }
    if (isLocked) {
      document.addEventListener("click", showLocker);
    }
    return () => {
      document.removeEventListener("click", showLocker);
    };
  }, [isLocked, showLock, selfRef]);

  if (!box) {
    return null;
  }

  const onDoubleClick = () => {
    //stänger av lint nedan, === krockar med javascriptjämförelsen, byte av typ gör att typescript inte kan användas
    // eslint-disable-next-line
    if (box.shelfNumber == 51) {
      handleSingleShelf();
    } else {
      return getSortBox !== undefined && getSortBox !== null && selectable && packable
        ? getSortBox(null, box.shelfNumber)
        : null;
    }
  };

  return (
    <div ref={selfRef} className={outerDivClasses} onDoubleClick={onDoubleClick}>
      <div>
        <div className="shelf-number">
          <span>{box.shelfNumber} </span>
        </div>
      </div>
      <div>
        <i aria-hidden="true" className={iconClasses}></i>
        <div>{isLocked ? "(" + mapWorkstationToSize(box.lockedWorkstation) + ")" : ""}</div>
      </div>
      {isLocked && showLock && box.isLockedByName ? (
        <div className={"locked-info"}>
          Låst av <b>{box.isLockedByName}</b>{" "}
        </div>
      ) : null}
    </div>
  );
};

export default CartBox;
